import React, { Component } from 'react'
import moment from 'moment'


export default class ApprovedRejectedDetalhes extends Component {

    state = {

    }

    render() {
        let row = this.props.row
        console.log("rowapprovedrejected",row)
        {/*````````````the rejected component detalhes```````````````````*/}       
        let onlyForApproved = (
            <React.Fragment>
                <div className="col-md-12 my-2">
                    <label><strong>Aprovados</strong></label>

                    <table className="w-100 text-center">
                        <thead className= "border">
                            <tr className="d-flex justify-content-around py-2">
                                <td className="w-25"><strong>Série</strong></td>
                                <td className="w-25"><strong>Nº inicial</strong></td>
                                <td className="w-25"><strong>Nº final</strong></td>
                                <td className="w-25"><strong>Nº Selos</strong></td>
                            </tr>
                        </thead>
                        <tbody className= "border">
                            <tr className="d-flex justify-content-around py-2">
                                <td className="w-25">{row['serie']}</td>
                                <td className="w-25">{row['nInicial']}</td>
                                <td className="w-25">{row['nFinal']}</td>
                                <td className="w-25">{row['nSelos'].trim()}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="col-md-12 my-2">
                    <label><strong>Observações da aprovação</strong></label>
                    <p>{row['observacaoAprovacao'] ? row['observacaoAprovacao'] : "nd"}</p>
                </div>
            </React.Fragment>
        )
        return (
            <React.Fragment>
               
                <div className="tab-content">
                    <div className="tab-pane active container" id="Detalhes">
                        <div className="row mt-3">
                            <div className="col-md-12 my-2">
                                <label><strong>Nº Pedido</strong></label>
                                <p>{row['nº pedido']}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Data de submissão</strong></label>
                                <p>{moment(row['dataCriado']).format('DD/MM/YY')}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Tipo de selo</strong></label>
                                <p>{row['tipoSelo']}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Observações do requisitante</strong></label>
                                <p>{row['observacaoAprovacao'] ? row['observacaoAprovacao'] : "nd"}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Estado do pedido</strong></label>
                                <p>{row['Estado']}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Saldo de selos (gráfica)</strong></label>
                                <p>{row['nSelos'].trim()}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Data decisão</strong></label>
                                <p>{row['Data de decisão']}</p>
                            </div>
                            <div className="col-md-12 my-2">
                                <label><strong>Responsável da decisão</strong></label>
                                <p>{row['responsavelRececao']}</p>
                            </div>

                            {/*````````````the rejected component detalhes```````````````````*/}

                            {(this.props.pedidos == "approved" || this.props.pedidos == "stampApproved") && onlyForApproved}

                        </div>
                    </div>

                </div>
            </React.Fragment>
        )
    }
}
